import ContextualMenu from './ContextualMenu'

export { ContextualMenu }
export default ContextualMenu
